import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styles from './ProfileToWatchModal.scss';
import BaseModal from '../../common/BaseModal/BaseModal';
import { getModalData } from '#/redux/modules/modal/selectors';
import { actions as modalActions } from '#/redux/modules/modal/actions';

const ProfileToWatchModal = () => {
  const dispatch = useDispatch();
  const { type, age, onSwitch, reducedProfiles = [] } = useSelector(state =>
    getModalData(state),
  );

  const profileTiles = useMemo(
    () =>
      reducedProfiles.map(profile => (
        <button
          type="button"
          className={styles.avatarCont}
          key={profile.id}
          onClick={() => {
            onSwitch(profile.id, type, age);
            dispatch(modalActions.closeModal());
          }}
        >
          <span className={styles.profileAvatar}>
            <img src={profile.avatar} alt="" />
          </span>
          <span className={styles.profileName}>{profile.name || ''}</span>
        </button>
      )),
    [age, dispatch, onSwitch, reducedProfiles, type],
  );

  return (
    <BaseModal
      showSaveButton={false}
      showCancelButton
      cancelButtonText="Dismiss"
      cancelButtonDisabled={false}
      cancelButtonClassName={styles.saveButton}
      buttonContainerClassName={styles.buttonContainer}
      className={styles.floatCenter}
      showCloseX={false}
    >
      <div className={styles.modalContainer}>
        <h2 className={styles.modalTitle}>Select a profile to watch</h2>
        <div className={styles.profileCont}>{profileTiles}</div>
      </div>
    </BaseModal>
  );
};

export default ProfileToWatchModal;
